import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { ShoppingBag, Star } from 'lucide-react';
interface ProductCardProps {
  title: string;
  description?: string;
  url: string;
  icon: React.ReactNode;
}
export function ProductCard({
  title,
  description,
  url,
  icon
}: ProductCardProps) {
  return <Card className="h-full flex flex-col group" data-id="element-32">
      <div className="p-6 flex-1 flex flex-col items-center text-center" data-id="element-33">
        <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-34">
          <div className="text-orange-600" data-id="element-35">{icon}</div>
        </div>

        <div className="flex items-center justify-center space-x-1 mb-3" data-id="element-36">
          {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-37" />)}
        </div>

        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2" data-id="element-38">
          {title}
        </h3>
        {description && <p className="text-sm text-gray-500 mb-4 line-clamp-3" data-id="element-39">
            {description}
          </p>}
      </div>

      <div className="p-6 pt-0 mt-auto" data-id="element-40">
        <a href={url} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-41">
          <Button variant="outline" fullWidth className="group-hover:bg-orange-50 group-hover:border-orange-200 group-hover:text-orange-700" data-id="element-42">
            View on Amazon
            <ShoppingBag className="w-4 h-4 ml-2" data-id="element-43" />
          </Button>
        </a>
      </div>
    </Card>;
}